module.exports = __webpack_public_path__ + "site/img/17.59a06191.jpg";